import React from 'react';
import { Box, Container } from '@mui/material';
import PositivePsychologySession from '../components/PositivePsychologySession';
import PersonalSessionInfo from '../components/PersonalSessionInfo';
import WhatToExpectFromSession from '../components/WhatToExpectFromSession';
import ProofSecond from '../components/ProofSecond';
import Footer from '../components/Footer';

const PositivePsychology = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
            <Box sx={{ mx: 'auto', px: { xs: 2, md: 0 }, py: 4 }}>
                <PositivePsychologySession />
                <WhatToExpectFromSession />
                <PersonalSessionInfo />
                {/* <ProofSecond /> */}
            </Box>
        </Box>
    );
};

export default PositivePsychology;